import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { authInterceptor } from '@interceptors/auth.interceptor';
import { headerInterceptor } from '@interceptors/header.interceptor';
import { googleTagManagerProvider } from '@providers/google-tag-manager.provider';
import { recaptchaProvider } from '@providers/recaptcha.provider';
import { routerProvider } from '@providers/router.provider';
import { sentryProvider } from '@providers/sentry.provider';
import { serviceWorkerProvider } from '@providers/service-worker.provider';
import { graphqlProvider } from './providers/graphql.provider';

export const appConfig: ApplicationConfig = {
  providers: [
    ...sentryProvider(),
    provideClientHydration(withEventReplay()),
    provideAnimationsAsync(),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor, headerInterceptor])),
    provideZonelessChangeDetection(),
    routerProvider,
    graphqlProvider,
    recaptchaProvider,
    serviceWorkerProvider,
    googleTagManagerProvider,
    MatIconRegistry,
  ],
};
